import { render } from "./App.vue?vue&type=template&id=46f7fb51&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=46f7fb51&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\버들이\\Documents\\Project\\John-I-gotta-go\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f7fb51"]])

export default __exports__